<template>
    <div
        :class="backgroundClassObject"
        class="rounded w-full relative"
        role="progressbar"
        :aria-valuenow="percent"
        aria-valuemin="0"
        aria-valuemax="100"
    >
        <div
            :class="foregroundClassObject"
            class="rounded text-center text-white text-sm transition flex flex-col justify-center"
            :style="`width: ${width}%; transition: width 2s;`"
        ></div>
        <div
            class="text-white absolute top-0 left-0 w-full h-full flex justify-center align-center tabular-nums"
            v-if="showText"
        >
            <slot>{{ position }} / {{ max }}</slot>
        </div>
    </div>
</template>

<script>
import { clamp } from 'lodash';

export default {
    name: 'ProgressBarCurrentMax',
    props: {
        current: {
            type: Number,
        },
        max: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            default: 'green',
        },
        backgroundColor: {
            type: String,
            required: false,
        },
        height: {
            type: String,
            default: 'default',
        },
        showText: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        position: function () {
            if (!this.current) {
                return 0;
            }
            return this.current;
        },
        bgColor: function () {
            if (this.backgroundColor) {
                return this.backgroundColor;
            }
            return this.color;
        },
        percent: function () {
            return Math.round((this.position / this.max) * 100);
        },
        width: function () {
            return clamp(this.percent, 0, 100);
        },
        backgroundClassObject: function component() {
            return {
                'bg-gray-900': this.bgColor === 'gray',
                'bg-red-900': this.bgColor === 'red',
                'bg-yellow-900': this.bgColor === 'yellow',
                'bg-green-900': this.bgColor === 'green',
                'bg-blue-900': this.bgColor === 'blue',
                'bg-indigo-900': this.bgColor === 'indigo',
                'bg-purple-900': this.bgColor === 'purple',
                'bg-pink-900': this.bgColor === 'pink',
                'bg-orange-900': this.bgColor === 'orange',
                'bg-lime-900': this.bgColor === 'lime',
                'bg-teal-900': this.bgColor === 'teal',
                'bg-fuchsia-900': this.bgColor === 'fuchsia',
                'bg-rose-900': this.bgColor === 'rose',
                'h-6': this.height === 'default',
                'h-1': this.height === 'xs',
                'h-2': this.height === 'sm',
                'h-3': this.height === 'md',
            };
        },
        foregroundClassObject: function component() {
            return {
                'bg-gray-600': this.color === 'gray',
                'bg-red-600': this.color === 'red',
                'bg-yellow-600': this.color === 'yellow',
                'bg-green-600': this.color === 'green',
                'bg-blue-600': this.color === 'blue',
                'bg-indigo-600': this.color === 'indigo',
                'bg-purple-600': this.color === 'purple',
                'bg-pink-600': this.color === 'pink',
                'bg-orange-600': this.color === 'orange',
                'bg-lime-600': this.color === 'lime',
                'bg-teal-600': this.color === 'teal',
                'bg-fuchsia-600': this.color === 'fuchsia',
                'bg-rose-600': this.color === 'rose',
                'h-6': this.height === 'default',
                'h-1': this.height === 'xs',
                'h-2': this.height === 'sm',
            };
        },
    },
};
</script>
